
import { Dealer } from "@/types/dealer";
import { Coordinates } from "./types";
import { fetchRecommendedDealersData } from "./fetchData";

/**
 * Refreshes dealers data with current parameters
 */
export async function refreshDealersData(
  selectedMetal: string,
  coordinates: Coordinates | null | undefined,
  fetchController: React.RefObject<AbortController | null>,
  setLoading: (loading: boolean) => void,
  setIsError: (isError: boolean) => void,
  setDealers: (dealers: Dealer[]) => void
): Promise<void> {
  console.log("Manual refreshDealersData called");
  
  // Cancel any in-progress request
  if (fetchController.current) {
    fetchController.current.abort();
  }
  
  // Create a new controller for this request
  const newController = new AbortController();
  
  try {
    setLoading(true);
    setIsError(false);
    
    const freshDealers = await fetchRecommendedDealersData(
      selectedMetal,
      coordinates,
      true,
      true,
      newController.signal
    );
    
    if (Array.isArray(freshDealers) && freshDealers.length > 0) {
      setDealers(freshDealers);
    } else {
      setIsError(true);
    }
  } catch (error: any) {
    if (error.name !== 'AbortError') {
      console.error("Error refreshing dealers data:", error);
      setIsError(true);
    }
  } finally {
    setLoading(false);
  }
}
